var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeriesA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 188,
    viewBox: "0 0 184 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1338_3573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.1906 141.97C82.5606 138.85 71.6606 134.34 64.8506 146.6C56.3206 161.96 72.3706 176.34 74.6606 178.2C82.2906 184.4 92.9106 189.37 103.201 181.01C111.821 174.01 109.731 165.4 104.631 159.93C101.801 156.89 96.8206 156.59 93.3706 153.37C89.9206 150.15 91.8306 145.1 87.2006 141.97H87.1906Z",
    stroke: "#ED533A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8711 143.49C88.8711 143.49 77.4311 154.37 85.7211 161.97C94.0011 169.57 102.851 158.48 102.851 158.48",
    stroke: "#ED533A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6615 178.2C74.6615 178.2 37.4415 148.77 72.9415 94.2001C97.9915 55.7001 110.712 40.8 95.4515 25.55",
    stroke: "#ED533A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4916 65.6701C95.1616 53.4801 91.4516 49.89 82.7016 35.72C73.9516 21.55 79.8216 2.30005 79.8216 2.30005C79.8216 2.30005 83.4616 11.02 91.0916 11.02C98.7216 11.02 115.952 12.62 118.332 33.99C121.242 60.06 96.3016 57.3901 91.4916 65.6701Z",
    stroke: "#ED533A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.46094 97.8301H181.541",
    stroke: "#ED533A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.46094 111.64H47.8709",
    stroke: "#ED533A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7012 111.64H181.541",
    stroke: "#ED533A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.58094 127.08H2.46094C1.36094 127.08 0.460938 126.18 0.460938 125.08C0.460938 123.98 1.36094 123.08 2.46094 123.08H2.58094C3.68094 123.08 4.58094 123.98 4.58094 125.08C4.58094 126.18 3.68094 127.08 2.58094 127.08Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.781 127.08H161.521C160.421 127.08 159.521 126.18 159.521 125.08C159.521 123.98 160.421 123.08 161.521 123.08H161.781C162.881 123.08 163.781 123.98 163.781 125.08C163.781 126.18 162.881 127.08 161.781 127.08Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.881 127.08H141.621C140.521 127.08 139.621 126.18 139.621 125.08C139.621 123.98 140.521 123.08 141.621 123.08H141.881C142.981 123.08 143.881 123.98 143.881 125.08C143.881 126.18 142.981 127.08 141.881 127.08Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.981 127.08H121.721C120.621 127.08 119.721 126.18 119.721 125.08C119.721 123.98 120.621 123.08 121.721 123.08H121.981C123.081 123.08 123.981 123.98 123.981 125.08C123.981 126.18 123.081 127.08 121.981 127.08Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.08 127.08H101.82C100.72 127.08 99.8203 126.18 99.8203 125.08C99.8203 123.98 100.72 123.08 101.82 123.08H102.08C103.18 123.08 104.08 123.98 104.08 125.08C104.08 126.18 103.18 127.08 102.08 127.08Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1819 127.08H81.9219C80.8219 127.08 79.9219 126.18 79.9219 125.08C79.9219 123.98 80.8219 123.08 81.9219 123.08H82.1819C83.2819 123.08 84.1819 123.98 84.1819 125.08C84.1819 126.18 83.2819 127.08 82.1819 127.08Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3811 127.08H42.1211C41.0211 127.08 40.1211 126.18 40.1211 125.08C40.1211 123.98 41.0211 123.08 42.1211 123.08H42.3811C43.4811 123.08 44.3811 123.98 44.3811 125.08C44.3811 126.18 43.4811 127.08 42.3811 127.08Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4807 127.08H22.2207C21.1207 127.08 20.2207 126.18 20.2207 125.08C20.2207 123.98 21.1207 123.08 22.2207 123.08H22.4807C23.5807 123.08 24.4807 123.98 24.4807 125.08C24.4807 126.18 23.5807 127.08 22.4807 127.08Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.542 127.08H181.422C180.322 127.08 179.422 126.18 179.422 125.08C179.422 123.98 180.322 123.08 181.422 123.08H181.542C182.642 123.08 183.542 123.98 183.542 125.08C183.542 126.18 182.642 127.08 181.542 127.08Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.772 140.52H171.512C170.412 140.52 169.512 139.62 169.512 138.52C169.512 137.42 170.412 136.52 171.512 136.52H171.772C172.872 136.52 173.772 137.42 173.772 138.52C173.772 139.62 172.872 140.52 171.772 140.52Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.862 140.52H151.602C150.502 140.52 149.602 139.62 149.602 138.52C149.602 137.42 150.502 136.52 151.602 136.52H151.862C152.962 136.52 153.862 137.42 153.862 138.52C153.862 139.62 152.962 140.52 151.862 140.52Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.951 140.52H131.691C130.591 140.52 129.691 139.62 129.691 138.52C129.691 137.42 130.591 136.52 131.691 136.52H131.951C133.051 136.52 133.951 137.42 133.951 138.52C133.951 139.62 133.051 140.52 131.951 140.52Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.041 140.52H111.781C110.681 140.52 109.781 139.62 109.781 138.52C109.781 137.42 110.681 136.52 111.781 136.52H112.041C113.141 136.52 114.041 137.42 114.041 138.52C114.041 139.62 113.141 140.52 112.041 140.52Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3108 140.52H52.0508C50.9508 140.52 50.0508 139.62 50.0508 138.52C50.0508 137.42 50.9508 136.52 52.0508 136.52H52.3108C53.4108 136.52 54.3108 137.42 54.3108 138.52C54.3108 139.62 53.4108 140.52 52.3108 140.52Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4006 140.52H32.1406C31.0406 140.52 30.1406 139.62 30.1406 138.52C30.1406 137.42 31.0406 136.52 32.1406 136.52H32.4006C33.5006 136.52 34.4006 137.42 34.4006 138.52C34.4006 139.62 33.5006 140.52 32.4006 140.52Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4905 140.52H12.2305C11.1305 140.52 10.2305 139.62 10.2305 138.52C10.2305 137.42 11.1305 136.52 12.2305 136.52H12.4905C13.5905 136.52 14.4905 137.42 14.4905 138.52C14.4905 139.62 13.5905 140.52 12.4905 140.52Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.58094 153.96H2.46094C1.36094 153.96 0.460938 153.06 0.460938 151.96C0.460938 150.86 1.36094 149.96 2.46094 149.96H2.58094C3.68094 149.96 4.58094 150.86 4.58094 151.96C4.58094 153.06 3.68094 153.96 2.58094 153.96Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.781 153.96H161.521C160.421 153.96 159.521 153.06 159.521 151.96C159.521 150.86 160.421 149.96 161.521 149.96H161.781C162.881 149.96 163.781 150.86 163.781 151.96C163.781 153.06 162.881 153.96 161.781 153.96Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.881 153.96H141.621C140.521 153.96 139.621 153.06 139.621 151.96C139.621 150.86 140.521 149.96 141.621 149.96H141.881C142.981 149.96 143.881 150.86 143.881 151.96C143.881 153.06 142.981 153.96 141.881 153.96Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.981 153.96H121.721C120.621 153.96 119.721 153.06 119.721 151.96C119.721 150.86 120.621 149.96 121.721 149.96H121.981C123.081 149.96 123.981 150.86 123.981 151.96C123.981 153.06 123.081 153.96 121.981 153.96Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3811 153.96H42.1211C41.0211 153.96 40.1211 153.06 40.1211 151.96C40.1211 150.86 41.0211 149.96 42.1211 149.96H42.3811C43.4811 149.96 44.3811 150.86 44.3811 151.96C44.3811 153.06 43.4811 153.96 42.3811 153.96Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4807 153.96H22.2207C21.1207 153.96 20.2207 153.06 20.2207 151.96C20.2207 150.86 21.1207 149.96 22.2207 149.96H22.4807C23.5807 149.96 24.4807 150.86 24.4807 151.96C24.4807 153.06 23.5807 153.96 22.4807 153.96Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.542 153.96H181.422C180.322 153.96 179.422 153.06 179.422 151.96C179.422 150.86 180.322 149.96 181.422 149.96H181.542C182.642 149.96 183.542 150.86 183.542 151.96C183.542 153.06 182.642 153.96 181.542 153.96Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.772 167.39H171.512C170.412 167.39 169.512 166.49 169.512 165.39C169.512 164.29 170.412 163.39 171.512 163.39H171.772C172.872 163.39 173.772 164.29 173.772 165.39C173.772 166.49 172.872 167.39 171.772 167.39Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.862 167.39H151.602C150.502 167.39 149.602 166.49 149.602 165.39C149.602 164.29 150.502 163.39 151.602 163.39H151.862C152.962 163.39 153.862 164.29 153.862 165.39C153.862 166.49 152.962 167.39 151.862 167.39Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.951 167.39H131.691C130.591 167.39 129.691 166.49 129.691 165.39C129.691 164.29 130.591 163.39 131.691 163.39H131.951C133.051 163.39 133.951 164.29 133.951 165.39C133.951 166.49 133.051 167.39 131.951 167.39Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3108 167.39H52.0508C50.9508 167.39 50.0508 166.49 50.0508 165.39C50.0508 164.29 50.9508 163.39 52.0508 163.39H52.3108C53.4108 163.39 54.3108 164.29 54.3108 165.39C54.3108 166.49 53.4108 167.39 52.3108 167.39Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4006 167.39H32.1406C31.0406 167.39 30.1406 166.49 30.1406 165.39C30.1406 164.29 31.0406 163.39 32.1406 163.39H32.4006C33.5006 163.39 34.4006 164.29 34.4006 165.39C34.4006 166.49 33.5006 167.39 32.4006 167.39Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4905 167.39H12.2305C11.1305 167.39 10.2305 166.49 10.2305 165.39C10.2305 164.29 11.1305 163.39 12.2305 163.39H12.4905C13.5905 163.39 14.4905 164.29 14.4905 165.39C14.4905 166.49 13.5905 167.39 12.4905 167.39Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.58094 180.83H2.46094C1.36094 180.83 0.460938 179.93 0.460938 178.83C0.460938 177.73 1.36094 176.83 2.46094 176.83H2.58094C3.68094 176.83 4.58094 177.73 4.58094 178.83C4.58094 179.93 3.68094 180.83 2.58094 180.83Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.781 180.83H161.521C160.421 180.83 159.521 179.93 159.521 178.83C159.521 177.73 160.421 176.83 161.521 176.83H161.781C162.881 176.83 163.781 177.73 163.781 178.83C163.781 179.93 162.881 180.83 161.781 180.83Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.881 180.83H141.621C140.521 180.83 139.621 179.93 139.621 178.83C139.621 177.73 140.521 176.83 141.621 176.83H141.881C142.981 176.83 143.881 177.73 143.881 178.83C143.881 179.93 142.981 180.83 141.881 180.83Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.981 180.83H121.721C120.621 180.83 119.721 179.93 119.721 178.83C119.721 177.73 120.621 176.83 121.721 176.83H121.981C123.081 176.83 123.981 177.73 123.981 178.83C123.981 179.93 123.081 180.83 121.981 180.83Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2815 180.83H62.0215C60.9215 180.83 60.0215 179.93 60.0215 178.83C60.0215 177.73 60.9215 176.83 62.0215 176.83H62.2815C63.3815 176.83 64.2815 177.73 64.2815 178.83C64.2815 179.93 63.3815 180.83 62.2815 180.83Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3811 180.83H42.1211C41.0211 180.83 40.1211 179.93 40.1211 178.83C40.1211 177.73 41.0211 176.83 42.1211 176.83H42.3811C43.4811 176.83 44.3811 177.73 44.3811 178.83C44.3811 179.93 43.4811 180.83 42.3811 180.83Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4807 180.83H22.2207C21.1207 180.83 20.2207 179.93 20.2207 178.83C20.2207 177.73 21.1207 176.83 22.2207 176.83H22.4807C23.5807 176.83 24.4807 177.73 24.4807 178.83C24.4807 179.93 23.5807 180.83 22.4807 180.83Z",
    fill: "#ED533A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.542 180.83H181.422C180.322 180.83 179.422 179.93 179.422 178.83C179.422 177.73 180.322 176.83 181.422 176.83H181.542C182.642 176.83 183.542 177.73 183.542 178.83C183.542 179.93 182.642 180.83 181.542 180.83Z",
    fill: "#ED533A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1338_3573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 183.08,
    height: 187.13,
    fill: "white",
    transform: "translate(0.460938 0.300049)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeriesA);
export default __webpack_public_path__ + "static/media/series-a.7ef02f83f9464f0595e18972fffccc53.svg";
export { ForwardRef as ReactComponent };